export default function isPreviewPage() {
  return window.__DPL_INITIAL_STATE?.server?.isPreview;
}
